import { toString as o } from "./_setup.js";
function e(e) {
  return !0 === e || !1 === e || "[object Boolean]" === o.call(e);
}
export { e as default };